import { setupAxiosInterceptors, isLocalDevHost } from './utils/apiClient';
import { startLocalhostHeartbeat } from './utils/backendHealth';

setupAxiosInterceptors();

// Localhost only: probe the backend on load, on tab refocus, and once a
// minute, so a dev server that died while the tab sat idle shows the
// BackendDownBanner before anyone clicks. Production stays passive.
if (isLocalDevHost()) {
  startLocalhostHeartbeat();
}
